package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable

const val MANUAL_VERIFICATION_TOKEN = "Manual Verification"

@Serializable
data class LoginRequest(
    val email: String,
    val password: String
)

@Serializable
data class SignupRequest(
    val name: String,
    val email: String,
    val password: String,
    val nationalId: String,
    val address: String,
    val phone: String,
    val workType: String,
    val position: String? = null,
    val organization: String? = null
)

@Serializable
data class LoginPayload(
    val token: String,
    val name: String,
    val email: String,
    val role: UserRole
)

@Serializable
sealed interface AuthenticatedEnvelope<out T> {
    val email: String
    val role: UserRole
    val request: T?
}

@Serializable
data class ForgotPasswordRequest(val email: String)

@Serializable
data class ResetPasswordRequest(val token: String, val newPassword: String)

@Serializable
data class ChangePasswordRequest(val currentPassword: String, val newPassword: String)